import axios from '@/libs/axios'

const API_URL = '/CalendarioEvaluacion'

export default {
  // Obtener todas las evaluaciones
  async getAll() {
    try {
      const response = await axios.get(API_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching calendario evaluaciones:', error)
      throw error
    }
  },

  // Obtener una evaluación por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching calendario evaluacion ${id}:`, error)
      throw error
    }
  },

  // Obtener evaluaciones por programación académica
  async getByProgramacion(programacionId) {
    try {
      const response = await axios.get(`${API_URL}/ByProgramacion/${programacionId}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching evaluaciones for programacion ${programacionId}:`, error)
      throw error
    }
  },

  // Obtener reporte de calendario de evaluaciones
  async getReporte(programacionId) {
    try {
      const response = await axios.get(`${API_URL}/Reporte/${programacionId}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching reporte evaluaciones for programacion ${programacionId}:`, error)
      throw error
    }
  },

  // Crear una evaluación
  async create(evaluacion) {
    try {
      const response = await axios.post(API_URL, evaluacion)
      return response.data
    } catch (error) {
      console.error('Error creating calendario evaluacion:', error)
      throw error
    }
  },

  // Crear múltiples evaluaciones (batch)
  async createBatch(batchData) {
    try {
      const response = await axios.post(`${API_URL}/Batch`, batchData)
      return response.data
    } catch (error) {
      console.error('Error creating batch calendario evaluaciones:', error)
      throw error
    }
  },

  // Actualizar una evaluación
  async update(id, evaluacion) {
    try {
      const response = await axios.put(`${API_URL}/${id}`, evaluacion)
      return response.data
    } catch (error) {
      console.error(`Error updating calendario evaluacion ${id}:`, error)
      throw error
    }
  },

  // Eliminar una evaluación (soft delete)
  async delete(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error deleting calendario evaluacion ${id}:`, error)
      throw error
    }
  },
}

